export default "__VITE_ASSET__0a76fc0b__"